
import React , {Component} from 'react';
import {withRouter } from "react-router-dom";
import cart from './api/cart';
import api from './api/api';

class ScrollToTop extends Component {

  componentDidMount() {
    this.loadDiscounts();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  loadDiscounts() {
        api.get('/ServiceKnowledgebase/discount')
        .then(res => {
            cart.selectedDiscountCode = res.data.length > 0 ? res.data[0].code : "";
        });
    }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)